import React from 'react';
import { Box, SxProps } from '@mui/material';

export default function BreakTextContainer({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
